import Tenant from "@/utilities/classes/tenant";
import Child from "@/utilities/classes/child";
import Income from "@/utilities/classes/income";
import Taxes from "@/utilities/classes/taxes";

export const addTenant = (tenantId, tenantArray) => {
    const tenant = new Tenant(tenantId + 1);
    tenantArray.push(tenant);
};
export const removeTenant = (tenantId, tenantArray) => {
    if(tenantArray.length == 1){
       alert("Must have at least 1 adult.") 
    }
    else{
        tenantArray.splice(tenantId - 1, 1);

        for(var i = tenantId  - 1; i < tenantArray.length; i++){
            tenantArray[i].id = tenantArray[i].id - 1;
        }
    }
};
export const addChild = (childId, childArray) => {
    
    const child = new Child(childId + 1);
    childArray.push(child);
};
export const removeChild = (childId, childArray) => {
   
    childArray.splice(childId - 1, 1);

    for(var i = childId  - 1; i < childArray.length; i++){
        childArray[i].id = childArray[i].id - 1;
    }
    
};
export const addIncome = (incomeId, incomeArray) => {
   
    const income = new Income(incomeId + 1);
    incomeArray.push(income);
};
export const removeIncome = (incomeId, incomeArray) => {
    
   
    if(incomeArray.length == 1){
       alert("Must have at least 1 income source.") 
    }
    else{
    incomeArray.splice(incomeId - 1, 1);

    for(var i = incomeId  - 1; i < incomeArray.length; i++){
        incomeArray[i].id = incomeArray[i].id - 1;
    }
}
    
};
export const addTaxes = (taxId, taxesArray) => {
   
    const taxes = new Taxes(taxId + 1);
    taxesArray.push(taxes);
};
export const removeTaxes = (taxId, taxesArray) => {
    
   
    // if(taxesArray.length == 1){
    //    alert("Must have at least 1 income source.") 
    // }
    // else{
    taxesArray.splice(taxId - 1, 1);

    for(var i = taxId  - 1; i < taxesArray.length; i++){
        taxesArray[i].id = taxesArray[i].id - 1;
    }
//} 
};
export const totalIncome = (income) => {
    // if(income.IncomeType == "No income source"){
    //     income.Income = 0;
    //     console.log("txt-income-" + income.id);
    //     document.getElementsByName("txt-income-" + income.id).readOnly = true;
    //     document.getElementsByName("txt-income-" + income.id).disabled = true;
    // }
    income.TotalIncome = Number(income.Income);
};

export const totalGrossTaxes = (taxes) => {
    taxes.TotalGrossAmount = Number(taxes.GrossAmount);
};

export const totalHouseholdIncome = (tenantArray) => {
    var TotalHouseholdIncome = 0;
    var TotalGrossTaxes = 0;
    for(var i = 0; i < tenantArray.length; i++){
        TotalHouseholdIncome += (tenantArray[i].TotalIncome != null ? tenantArray[i].TotalIncome : 0);
    }
    for(var j = 0; j < tenantArray.length; j++){
        TotalGrossTaxes += (tenantArray[j].TotalGrossAmount != null ? tenantArray[j].TotalGrossAmount : 0);
    }
    return (TotalHouseholdIncome >= TotalGrossTaxes) ? TotalHouseholdIncome : TotalGrossTaxes;
};